import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataFetched: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "blocksSounds",
  initialState: initialState,
  reducers: {
    getBlocksSoundsData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    setBlocksSoundsLevel: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getBlocksSoundsDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.dataFetched = true;
    },
    getBlocksSoundsDataError: (state, action) => {
      state.error = action.payload;
      state.dataFetched = false;
      state.loading = false;
    },
    blocksSoundsResetState: () => initialState,
  },
});

export const {
  getBlocksSoundsData,
  setBlocksSoundsLevel,
  getBlocksSoundsDataSuccess,
  getBlocksSoundsDataError,
  blocksSoundsResetState,
} = slice.actions;

export default slice.reducer;
